import { Component, OnInit } from '@angular/core'

import { MatCardModule } from '@angular/material/card'
import { CommonModule } from '@angular/common'

import { LocalStorageService } from 'src/app/shared/services/local-storage.service'
import { NivelProgramaPipe } from '../../pipes/nivel-programa.pipe'
import { PerfilPipe } from '../../pipes/perfil.pipe'

@Component({
  selector: 'app-identificacao-usuario',
  templateUrl: './identificacao-usuario.component.html',
  styleUrls: ['./identificacao-usuario.component.css'],
  imports: [CommonModule, MatCardModule, NivelProgramaPipe, PerfilPipe],
})
export class IdentificacaoUsuarioComponent implements OnInit {
  perfil: string = ''
  nome: string = ''
  ra: string = ''
  programa?: string
  curso?: string
  campus?: string

  constructor(private localStorageService: LocalStorageService) {}

  ngOnInit(): void {
    let valorEmCache = this.localStorageService.get('identificacaoUsuario')
    this.perfil = this.localStorageService.get('perfil')
    this.nome = valorEmCache['nome']
    this.ra = valorEmCache['numero']
    this.programa = valorEmCache['programa']
    this.curso = valorEmCache['curso']
    this.campus = valorEmCache['campus']
  }
}
